import { render } from "./CRMWhatsappMediaCatalogsView.vue?vue&type=template&id=4f83f662"
import script from "./CRMWhatsappMediaCatalogsView.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappMediaCatalogsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__